<template>
  <main>
    <div class="row">
      <div class="small-4 columns">
        <h1 class="page-header">campaigns</h1>
      </div>
      <div class="small-8 columns">
        <template v-if="hasAccess(userAbilitiesValue, 'CAMPAIGNS_CREATE')">
          <a v-if="classicCampaignsEnabled" href="/classic_campaigns/new" id="campaign-new-link" class="button larger float-right">
            new campaign
          </a>
          <a v-else href="/campaigns/new" id="campaign-new-link" class="button larger float-right" data-cy="new-campaign-button">
            new campaign
          </a>
        </template>
        <div v-if="hasShowBrandsEnabled && hasAdsAvailable" class="notification float-right hide-for-small-only">
          sponsored campaigns available
        </div>
      </div>
    </div>
    <div v-if="creditAlertOptions.show" class="callout notice" id="low-credit-alert">
      <h5>low credit alert</h5>
      <h6>you have&nbsp;{{creditAlertOptions.allowed_sms_count}} textable members, but only&nbsp;{{creditAlertOptions.sms_credit_balance}} credits available</h6>
      <a v-if="creditAlertOptions.credit_card_stored" class="button" href="/invoices/new">buy more credits</a>
      <div v-else>
        <p>please add a credit card to buy more credits</p>
        <a class="button" href="/billing_addresses/new">add credit card</a>
      </div>
    </div>
    <div class="row" v-if="sendingCampaigns.length > 0">
      <div class="medium-12 columns">
        <div id="sending-campaigns">
          <div class="data-title text-center">
            sending now
          </div>
          <table class="unstriped">
            <thead>
              <tr>
                <th/>
                <th class="text-center">message</th>
                <th class="text-center">campaign id</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="campaign in sendingCampaigns">
                <tr @click="redirectToCampaign(campaign.id)">
                  <td class="text-center">
                    <img v-if="campaign.parent_id" :src="arrow21" alt="backup_campaign" class="campaign_icon"/>
                    <img v-if="campaign.primary" :src="p21" alt="primary_campaign" class="campaign_icon"/>
                  </td>
                  <td class="text-center hide-for-small-only">
                    {{truncateText(campaign.title, 80)}}
                  </td>
                  <td class="text-center mobile-link show-for-small-only">
                    {{truncateText(campaign.title, 40)}}
                  </td>
                  <td class="text-center">
                    {{campaign.id}}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row" v-if="pendingCampaigns.length > 0">
      <div class="medium-12 columns">
        <div id="pending-campaigns">
          <div class="data-title text-center">
            pending
          </div>
          <table class="unstriped">
            <thead>
              <tr>
                <th/>
                <th class="text-center">message</th>
                <th class="text-center">campaign id</th>
              </tr>
            </thead>
            <tbody>
            <template v-for="campaign in pendingCampaigns">
              <tr @click="redirectToCampaign(campaign.id)">
                <td class="text-center">
                  <img v-if="campaign.parent_id" :src="arrow21" alt="backup_campaign" class="campaign_icon"/>
                  <img v-if="campaign.primary" :src="p21" alt="primary_campaign" class="campaign_icon"/>
                </td>
                <td class="text-center hide-for-small-only">
                  {{truncateText(campaign.title, 80)}}
                </td>
                <td class="text-center mobile-link show-for-small-only">
                  {{truncateText(campaign.title, 40)}}
                </td>
                <td class="text-center">
                  {{campaign.id}}
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="medium-12 columns">
        <ul class="tabs" id="campaign-tabs" data-tabs="">
          <li class="tabs-title is-active">
            <a id="track-tab" aria-selected="true" href="#track-campaigns-tab" data-cy="sent-tab">
              sent
            </a>
          </li>
          <li class="tabs-title" :class="{'last':rejectedCampaigns.length === 0}">
            <a id="scheduled-tab" data-tabs-target="scheduled-campaigns-tab" href="#scheduled-campaigns-tab" data-cy="scheduled-tab">
              scheduled
            </a>
          </li>
          <li :class="{'hide':rejectedCampaigns.length === 0}" class="tabs-title">
            <a id="rejected-tab" data-tabs-target="rejected-campaigns-tab" href="#rejected-campaigns-tab" data-cy="rejected-tab">
              rejected
            </a>
          </li>
        </ul>
        <div class="tabs-content" data-tabs-content="campaign-tabs">
          <div id="track-campaigns-tab" class="tabs-panel">
            <div class="m-6" v-if="sentCampaigns.length > 0">
              <div class="text-center">
                tracking duration post customer reception of campaign
              </div>
              <div class="duration-container flex flex-row content-center justify-center">
                <template v-for="duration in trackingDurationList">
                  <input
                    v-model="trackingDuration"
                    class="tracking-duration-radio"
                    type="radio"
                    :value="duration"
                    :name="'duration-' + duration"
                    :id="'duration-' + duration"/>
                  <label
                    class="tracking-duration-container"
                    :key="`radio-${duration}`"
                    :for="'duration-' + duration">
                    {{ duration }}
                  </label>
                </template>
              </div>
            </div>
            <div class="data-description text-center">updates every 30 minutes</div>
            <div v-if="sentCampaignsLoading" class="flex justify-center">
              <sb-loading-icon/>
            </div>
            <template v-else>
              <h4 v-if="sentCampaigns.length === 0" class="data-title text-center">create your first campaign</h4>
              <div v-else>
                <table>
                  <thead>
                    <tr>
                      <th v-if="isCompare"/>
                      <th class="text-left hide-for-small-only">
                        message
                      </th>
                      <th class="text-center">
                        date sent
                      </th>
                      <th class="text-center hide-for-small-only">
                        messages sent
                      </th>
                      <th class="text-center">
                        clicks
                      </th>
                      <th class="text-center hide-for-small-only">
                        visits
                      </th>
                      <th class="text-center">
                        visitor spend
                      </th>
                      <th class="text-center">
                        spend/recipient
                      </th>
                      <th class="text-center hide-for-small-only">
                        extension
                      </th>
                      <th class="text-center hide-for-small-only">
                        actions
                      </th>
                    </tr>
                  </thead>
                  <tbody class="sent-campaign">
                    <template v-for="(campaign, index) in sentCampaigns">
                      <tr @click="redirectToCampaign(campaign.id)">
                        <td v-if="isCompare" v-on:click.stop>
                          <input
                            :id="campaign.id"
                            type="checkbox"
                            class="compare-checkbox"
                            :value="campaign.id"
                            v-model="selectedCampaignIds"
                            :disabled="selectedCampaignIds.length >= 4 && selectedCampaignIds.indexOf(campaign.id) === -1"
                          />
                        </td>
                        <td class="hide-for-small-only title-25">
                          {{truncateText(campaign.title, 25)}}
                        </td>
                        <td class="text-center">
                          {{campaign.sent_at}}
                        </td>
                        <td class="text-center hide-for-small-only sms-counts" :class="[`count-id-${campaign.id}`]">
                          {{campaign.sms_sent + campaign.push_sent + campaign.email_sent}}
                        </td>
                        <td class="text-center clicks-count">
                          <a class="clicks-count" :data-id="campaign.id">
                            {{campaign.clicks.count}}({{campaign.clicks.percentage.toFixed(1)}}%)
                          </a>
                        </td>
                        <td class="text-center visit-calculations hide-for-small-only">
                          {{campaign.visits_calculations.count}}({{campaign.visits_calculations.count_percentage.toFixed(1)}}%)
                        </td>
                        <td class="text-center visitor-spend">
                          {{campaign.visits_calculations.spend}}
                        </td>
                        <td class="text-center visitor-spend">
                          {{campaign.visits_calculations.spend_recipient_average}}
                        </td>
                        <td class="text-center hide-for-small-only">
                          <template v-if="campaign._type === 1">
                            digital voucher
                          </template>
                          <template v-else-if="campaign._type === 5">
                            bonus points
                          </template>
                          <template v-else-if="campaign._type === 6">
                            instant points
                          </template>
                          <template v-else-if="campaign._type === 3">
                            target wallet
                          </template>
                          <template v-else-if="campaign._type === 4">
                            any link
                          </template>
                          <template v-else>
                            --
                          </template>
                        </td>
                        <td :class="['text-center', 'hide-for-small-only', {'redemptions-rate': [1, 5].includes(campaign._type)}]">
                          <template v-if="[1, 5].includes(campaign._type)">
                            {{`${campaign.redemptions_rate_calculation.count}(${campaign.redemptions_rate_calculation.percentage.toFixed(1)}%)`}}
                          </template>
                          <template v-else>
                            --
                          </template>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div class="row">
                <div class="w-full columns flex flex-col place-content-between md:flex-row-reverse md:flex-row items-center">
                  <div class="flex-1 m-2 max-w-2/5 md:max-w-full md:m-0 order-2 md:order-1 text-center md:text-right" :disabled="selectedCampaignIds.length > 4" v-if="sentCampaigns.length > 0">
                    <button class="generate-csv-btn"
                            :disabled="selectedCampaignIds.length > 4"
                            @click="showExportModal=!showExportModal">
                      export campaign data
                    </button>
                  </div>
                  <div class="max-w-2/3 md:max-w-full text-center m-2 md:m-0 md:order-2">
                    <pagination
                      v-if="totalPages > 1"
                      :page.sync="currentPage"
                      :pages="totalPages"
                      :gap="2"
                    />
                  </div>
                  <div class="compare-container flex flex-1 justify-center md:justify-start m-2 md:m-0 md:order-3">
                    <template v-if="hasCampaignCompare && sentCampaigns.length > 0">
                      <div class="compare-btn p-2 flex bg-blue" v-if="!isCompare" @click="isCompare=!isCompare">
                        <fai :icon="['fas', 'code-compare']" class="compare-icon"/>
                        <span class="ml-2 mr-2 bg-blue ">compare campaigns</span>
                      </div>
                      <div class="compare-info p-2 flex" v-if="isCompare">
                        <fai :icon="['fas', 'code-compare']" class="compare-icon"/>
                        <span class="ml-2">compare selected ({{selectedCampaignIds.length === 4 ? 'max' : selectedCampaignIds.length}})</span>
                      </div>
                      <template v-if="isCompare">
                        <button
                          class="compare-view-btn ml-1"
                          :disabled="!(selectedCampaignIds.length > 1 && selectedCampaignIds.length <= 5)"
                          @click="redirectToCampaignCompare"
                        >
                          view
                        </button>
                        <button class="compare-cancel-btn ml-1" @click="cancelCompare">
                          cancel
                        </button>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div id="scheduled-campaigns-tab" class="tabs-panel">
            <h4 v-if="scheduledCampaigns.length === 0 " class="data-title text-center">no scheduled campaigns</h4>
            <table v-else class="unstriped">
              <thead>
                <tr>
                  <th/>
                  <th>message</th>
                  <th class="text-center">tracked</th>
                  <th class="text-center">scheduled for</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(campaign, index) in scheduledCampaigns">
                  <tr @click="redirectToCampaign(campaign.id)">
                    <td class="text-center">
                      <img v-if="campaign.parent_id" :src="arrow21" alt="backup_campaign" class="campaign_icon"/>
                      <img v-if="campaign.primary" :src="p21" alt="primary_campaign" class="campaign_icon"/>
                    </td>
                    <td class="text-left hide-for-small-only">
                      {{truncateText(campaign.title, 50)}}
                    </td>
                    <td class="text-left mobile-link show-for-small-only">
                      {{truncateText(campaign.title, 20)}}
                    </td>
                    <td v-if="[1,5,6].includes(campaign._type)" class="text-center" style="min-width: 25%">
                      offer link
                    </td>
                    <td v-if="campaign._type === 2" class="text-center" style="min-width: 25%">
                      product link
                    </td>
                    <td v-if="campaign._type === 3" class="text-center" style="min-width: 25%">
                      wallet link
                    </td>
                    <td v-else class="text-center" style="min-width: 25%">
                      --
                    </td>
                    <td v-if="campaign.send_at" class="text-center hide-for-small-only" style="min-width: 25%">
                      {{ campaign.send_at }}
                    </td>
                    <td v-else/>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div id="rejected-campaigns-tab" class="tabs-panel" v-if="rejectedCampaigns.length > 0">
            <table class="unstriped">
              <thead>
                <tr>
                  <th>message</th>
                  <th>created at</th>
                  <th/>
                </tr>
              </thead>
              <tbody>
                <template v-for="(campaign, index) in rejectedCampaigns">
                  <tr @click="redirectToCampaign(campaign.id)">
                    <td class="text-left hide-for-small-only">
                      {{truncateText(campaign.title, 90)}}
                    </td>
                    <td class="text-left mobile-link show-for-small-only">
                      {{truncateText(campaign.title, 40)}}
                    </td>
                    <td>
                      {{campaign.created_at}}
                    </td>
                    <td class="text-center">
                      <img v-if="campaign.parent_id" :src="arrow21" alt="backup_campaign" class="campaign_icon"/>
                      <img v-if="campaign.primary" :src="p21" alt="primary_campaign" class="campaign_icon"/>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <modal
      v-if="showExportModal"
      class="export-modal"
      modal-class="generate-csv-modal"
      :showClose="true"
      @close="closeExportModal">
      <h6 slot="header" class="modal-header-title">export campaign data</h6>
      <div slot="body" class="body text-center">
        <p v-if="selectedCampaignIds.length === 0">
          select a date interval of campaigns to include in the report:
        </p>
        <p v-else>
          are you sure you would like to export data from these campaigns?
        </p>
        <div class="row text-center">
          <select
            v-model="exportTrackingDuration"
            name="export_trackind_duration"
            class="small-6 m-2"
            id="export_trackind_duration">
            <template v-for="duration in trackingDurationList">
              <option :value="duration">{{duration}}</option>
            </template>
          </select>
        </div>
        <div class="date-range mt-8" v-if="selectedCampaignIds.length === 0">
          <sb-date-range
            :start.sync="eventRangeMin"
            :end.sync="eventRangeMax"
            placeholder="choose date"
            format="M-d-Y"
            v-on:update:range="resetExportModal"
            class="w-full mb-4 flex justify-center export-modal-date-range"
          />
        </div>
      </div>

      <div slot="action" class="action-container mt-8">
        <div class="btn-action export"
             v-if="!reportLink &&((eventRangeMax && eventRangeMin)||selectedCampaignIds.length > 0)"
             :class="{disable: disableExportBtnText}"
             @click="exportCampaign">{{ exportBtnText }}
        </div>
        <a v-if="reportLink"
           class="btn-action download"
           :href="reportLink">download</a>
        <div class="cancel-btn"
             @click="closeExportModal">
          done
        </div>
      </div>
    </modal>
  </main>
</template>
<script>
import {mapGetters, mapState} from "vuex";
import { campaignAPI } from "../../services/api/campaignAPI";
import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin';
import { truncateWithEllipses } from "../../utilities";
import { Pagination } from '@springbig/sb-components';
import p21 from 'p21.svg';
import arrow21 from 'arrow21.svg';
import Modal from '../../components/shared/Modal'
import AxiosMixin from '../../mixins/AxiosMixin'
import {format} from "date-fns-tz";
import {trackingDurationList} from "../../config/tracking";
import {reportsAPI, reportsAPI as reportsApi} from "../../services/api/reportsAPI";
import LoadErrorMixin from '../../mixins/LoadErrorMixin'

export default {
  name: 'CampaignIndex',
  components: {
    Pagination,
    Modal
  },
  data() {
    return {
      sendingCampaigns: [],
      pendingCampaigns: [],
      rejectedCampaigns: [],
      sentCampaigns: [],
      scheduledCampaigns: [],
      currentPage: 0,
      totalPages: 0,
      pagination: {},
      showArrows: true,
      showExportModal: false,
      exportBtnText: 'export',
      disableExportBtnText: false,
      eventRangeMin: null,
      eventRangeMax: null,
      reportLink: '',
      selectedCampaignIds: [],
      trackingDuration: '2d',
      exportTrackingDuration: '2d',
      isCompare: false,
      sentCampaignsLoading: true,
      p21,
      arrow21,
      trackingDurationList,
    }
  },
  async created() {
    this.$store.dispatch('LOAD_CURRENT_USER')
    this.$store.dispatch('LOAD_CURRENT_MERCHANT')
    await this.fetchSendingCampaigns();
    await this.fetchPendingCampaigns();
    await this.fetchScheduledCampaigns();
    await this.fetchRejectCampaigns();
    await this.fetchSentCampaigns();
  },

  mixins: [UserAbilitiesMixin, AxiosMixin, LoadErrorMixin],
  computed: {
    ...mapGetters([
      'classicCampaignsEnabled',
      'hasShowBrandsEnabled',
      'hasAdsAvailable',
      'userAbilitiesValue',
      'hasCampaignCompare',
      'creditAlertOptions'
    ])
  },
  watch: {
    currentPage() {
      this.fetchSentCampaigns();
    },
    trackingDuration() {
      this.fetchSendingCampaigns();
      this.fetchPendingCampaigns();
      this.fetchScheduledCampaigns();
      this.fetchRejectCampaigns();
      this.fetchSentCampaigns();
    }
  },
  methods: {
    async fetchSendingCampaigns() {
      const data = await campaignAPI.getCampaigns("sending", this.trackingDuration)
      this.sendingCampaigns = data.campaigns
    },
    async fetchPendingCampaigns() {
      const data = await campaignAPI.getCampaigns("pending", this.trackingDuration)
      this.pendingCampaigns = data.campaigns
    },
    async fetchRejectCampaigns() {
      const data = await campaignAPI.getCampaigns("rejected", this.trackingDuration)
      this.rejectedCampaigns = data.campaigns
    },
    async fetchSentCampaigns() {
      this.sentCampaignsLoading = true
      const data = await campaignAPI.getCampaigns("sent", this.trackingDuration, this.currentPage + 1)
      this.sentCampaigns = data.campaigns
      this.totalPages = data.pagination?.total_pages
      this.pagination = data.pagination
      this.sentCampaignsLoading = false
    },
    async fetchScheduledCampaigns() {
      const data = await campaignAPI.getCampaigns("scheduled", this.trackingDuration)
      this.scheduledCampaigns = data.campaigns
    },
    changePage(page) {
      this.currentPage = page
      this.fetchSentCampaigns();
    },
    truncateText: function(text, max) {
      return truncateWithEllipses(text, max)
    },
    resetExportModal() {
      this.disableExportBtnText = false
      this.reportLink = null
      this.exportBtnText = 'export'
    },
    closeExportModal() {
      this.showExportModal = false
      this.eventRangeMin = null
      this.eventRangeMax = null
      this.resetExportModal()
    },
    async exportCampaign() {
      this.loadingReport = true;
      const report = await reportsAPI.initializeReportJob({
        report: {
          type: 'Reports::CampaignExportReport',
          input_data: {
            event_value: this.selectedCampaignIds,
            event_range_min: this.eventRangeMin ? format(this.eventRangeMin, 'yyyy-MM-dd') : null,
            event_range_max: this.eventRangeMax ? format(this.eventRangeMax, 'yyyy-MM-dd') : null,
            duration: this.exportTrackingDuration
          }
        }
      });
      this.checkResponseStatus(report.id)
    },
    redirectToCampaign(id) {
      window.location = `/campaigns/${id}`;
    },
    redirectToCampaignCompare() {
      window.location = `/campaigns/compare/?campaign_ids[]=${this.selectedCampaignIds}`;
    },
    cancelCompare() {
      this.selectedCampaignIds = []
      this.isCompare = false
    },
    checkResponseStatus(id) {
      this.disableExportBtnText = true
      this.exportBtnText = 'waiting...'
      let interval = setInterval(() => {
        reportsAPI.fetchReport(id)
          .then(({ report }) => {
            if (report.download_url) {
              this.reportLink = report.download_url
              clearInterval(interval)
            }
            // add countdown to btn
            if (report.estimated_run_time_remaining) {
              this.exportBtnText = report.estimated_run_time_remaining
            } else {
              clearInterval(interval)
              this.exportBtnText = 'export again'
            }
            this.disableExportBtnText = false
          }).catch(error => {
            this.showExportModal = false
            clearInterval(interval)
            this.setLoadError(error)
            this.disableExportBtnText = false
          })
      }, 1000)
    },
  }
}
</script>
<style lang="scss" scoped>
  .compare-checkbox {
    margin: 0;
  }
  .modal-header-title {
    font-size: 22px !important;
  }
  .compare-container{
    .compare-icon{
      height: 22px;
      color: #128FF9;
    }
    .compare-info{
      border: 1px solid #128FF9;
      border-radius: 8px;
      height: 40px;
      span{
        color: #128FF9;
        font-family: AileronThin;
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
      }
    }
    .compare-cancel-btn{
      color: #A4A4A4;
      font-family: AileronThin;
      font-size: 16px;
      line-height: 19px;
      cursor: pointer;
      &:hover{
        color: #F91253;
      }
    }
    .compare-view-btn{
      background-color: #128FF9;
      border: 1px solid #128FF9;
      border-radius: 8px;
      width: 59px;
      height: 40px;
      color: #FFFFFF;
      font-family: AileronThin;
      font-size: 16px;
      line-height: 19px;
      cursor: pointer;
      &:disabled{
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
    .compare-btn{
      color: #FFFFFF;
      border-radius: 8px;
      cursor: pointer;
      svg{
        color: #FFFFFF;
      }
    }
  }

</style>
